export default "__VITE_ASSET__d384c5fc__"